/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";

import Header2 from "parts/Header2";
import HeroPortfolio2 from "parts/HeroPortfolio2";
import Discuss2 from "parts/Discuss2";
import Footer2 from "parts/Footer2";
import AllPortfolio2 from "parts/AllPortofolio2";

import { Portfolios } from "json/landingPageData2";

export default class ProjectPage2 extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header2 />
        <HeroPortfolio2 />
        <AllPortfolio2 data={Portfolios} />
        <Discuss2 />
        <Footer2 />
      </>
    );
  }
}
